// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-index-productDay-glbce{width:100%}.pages-index-productDayWrapper-twdng.pages-index-mobile-bxlun{margin-left:-16px;margin-right:-16px}.pages-index-productsBlock3-bfryz{margin-bottom:24px}.pages-index-productsBlock3-bfryz:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productDay": "pages-index-productDay-glbce",
	"productDayWrapper": "pages-index-productDayWrapper-twdng",
	"mobile": "pages-index-mobile-bxlun",
	"productsBlock3": "pages-index-productsBlock3-bfryz"
};
module.exports = ___CSS_LOADER_EXPORT___;
